import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/typing-speed-test")({
  component: TypingSpeedTestLayout,
});

function TypingSpeedTestLayout() {
  return <Outlet />;
}
